import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { RootState } from "../store"

export const summariesApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_API_URL}/${import.meta.env.VITE_APP_API_VERSION}`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState
      const authToken = state.auth.masquerade_access_token || state.auth.api_access_token
      const tokenType = state.auth.token_type
      headers.set("Content-Type", "application/json")
      headers.set("Accept", "application/json")
      if (authToken) {
        headers.set("authorization", `${tokenType} ${authToken}`)
      }
      return headers
    },
  }),

  reducerPath: "summariesApi",
  tagTypes: ["Quiz", "Answer"],
  endpoints: (builder) => ({
    getSummary: builder.mutation({
      query: (payload) => ({
        url: `/summary/getsummary`,
        method: "POST",
        body: payload,
      }),
    }),
    getSummaryById: builder.mutation({
      query: (payload) => ({
        url: `summary/getsummarybyid`,
        method: "POST",
        body: payload,
      }),
    }),
    saveSummary: builder.mutation({
      query: (payload) => ({
        url: `/summary/savesummary`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
})

export const { useGetSummaryByIdMutation, useSaveSummaryMutation, useGetSummaryMutation } = summariesApi
